import { Icon, Tag, Text, colors } from "@asurion-core/mx-asurion-ui-react";
import { BetaIcon, DetailsContainer, DetailsWrapperContainer, HighlightText } from "@ubif/components";
import { GetSalesOrderResponse } from "@ubif/types";
import { formatDateAsMMDDYYY } from "@ubif/util-store";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { FlexContactWrapperContainer, FlexNameWrapperContainer } from "./FlexContainers";

type QuickSearchArrivalDetailsProps = {
  fullName: string;
  salesOrder: GetSalesOrderResponse;
  onClick: (salesOrder: string) => void;
};

export const QuickSearchSalesorderDetails = ({ fullName, salesOrder, onClick }: QuickSearchArrivalDetailsProps) => {
  const { t } = useTranslation("root-config");
  const handleClick = () => {
    onClick(salesOrder.customerSale.csuSalesOrderId);
  };

  return (
    <StyledQuickSearchArrivalDetails onClick={handleClick}>
      <BetaIcon aria-hidden="true" fill={colors.neutralDeepest} size="medium" src="bookmarks-and-tags/tag-dollar.svg" />

      <DetailsContainer>
        <FlexNameWrapperContainer>
          <HighlightText
            highlightText={fullName}
            wholeText={`${t("GlobalSearch.SalesOrderId", { salesOrderId: salesOrder.customerSale.csuSalesOrderId })} |`}
          />
          <HighlightText highlightText={fullName} wholeText={fullName} />
        </FlexNameWrapperContainer>
        <FlexNameWrapperContainer>
          <StyledContact>
            <Icon src="time/calendar-check-2.svg" size="normal" />
            <StyledContactText>
              <Text size={1} color={colors.neutralDeepest}>
                {formatDateAsMMDDYYY(
                  typeof salesOrder.customerSale.createdAt === "string"
                    ? salesOrder.customerSale.createdAt
                    : salesOrder.customerSale.createdAt.toISOString()
                )}
              </Text>
            </StyledContactText>
          </StyledContact>
          <StyledContact>
            <Icon src="shopping/receipt-3.svg" size="normal" />
            <StyledContactText>
              <Text size={1} color={colors.neutralDeepest}>
                {`$${salesOrder?.csuSalesOrder?.payment?.total}`}
              </Text>
            </StyledContactText>
          </StyledContact>
        </FlexNameWrapperContainer>

        <FlexContactWrapperContainer>
          {salesOrder.isRefurbishedDevice && <Tag text={t("RefurbishedDeviceSale")} type={"update"} />}
        </FlexContactWrapperContainer>
      </DetailsContainer>
    </StyledQuickSearchArrivalDetails>
  );
};

const StyledQuickSearchArrivalDetails = styled(DetailsWrapperContainer)`
  background-color: var(--aui-elevated-level-01);
  color: var(--aui-on-surface);

  &:hover {
    background-color: var(--aui-outline-soft);
    border-radius: 0.5rem;
    cursor: pointer;
  }
`;

const StyledContact = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const StyledContactText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
`;
